import { ConsultationTreatmentTypes } from '@enums/consultation-treatment-types';
import { ConsultationTypes } from '@enums/consultation-types';
import { ConsultationRequestPharmacy } from '@models/consultation-request/consultation-request-pharmacy';

export class ConsultationRequest {
  public id: string;
  public first_name: string;
  public last_name: string;
  public email: string;
  public allergies: string | null;
  public prescriptions: string | null;
  public health_info: string | null;
  public phone: string;
  public reschedule_url: string;
  public consultation_status: string;
  public treatment_type: ConsultationTreatmentTypes;
  public type: ConsultationTypes;
  public will_start_at: string | null;
  public pharmacy: ConsultationRequestPharmacy;
}
